module.exports = __webpack_public_path__ + "img/alert.ac554965.svg";